import { render, staticRenderFns } from "./tendency-chart.vue?vue&type=template&id=21febe1e&scoped=true&"
import script from "./tendency-chart.vue?vue&type=script&lang=js&"
export * from "./tendency-chart.vue?vue&type=script&lang=js&"
import style0 from "./tendency-chart.vue?vue&type=style&index=0&id=21febe1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21febe1e",
  null
  
)

export default component.exports